import { connect } from 'react-redux'
import AttachmentNeededWidget from './AttachmentNeededWidget'
import { isAttachmentProviderStore } from '../../../globals/state/selector'
import { selectCustomer } from '../../../customer/state/detail/selector'
import * as action from '../../../treatment/state/plan/action'
import { selectIsFetching } from "../../../anamnesis/state/anamnesis/selector";
import { selectIsTaskReadOnly } from "../../state/task-detail/selector";
import * as selector from '../../../treatment/state/plan/selector'

const mapStateToProps = (state, props) => {
    const customer = selectCustomer(state)

    return {
        readOnly: typeof props.readOnly === "boolean" ? props.readOnly : selectIsTaskReadOnly(state),
        fetching: selectIsFetching(state),
        isAttachmentProviderStore: isAttachmentProviderStore(state, customer.store),
        treatmentPlan: selector.selectTreatmentPlan(state)
    }
}

const mapDispatchToProps = {
    saveTreatmentPlan: action.saveTreatmentPlan,
    changeTreatmentPlan: action.changeTreatmentPlan,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AttachmentNeededWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/AttachmentNeededWidgetContainer.js